import { ProviderAttributeModel } from "./ProviderAttributeModel";

export class ProviderModel {
  ID: number;
  IDEncrypted: string;
  ProviderName: string;
  Description: string;
  TypeFullName:string;
  IsDefault: boolean;
  IsRunning: boolean;
  OrganizationID:number;
  ProviderTypeItemID:number;
  ProviderAttributes : ProviderAttributeModel[] = [];
}
